<template>
  <div class="mt-6">
    <div>
      <!-- <div class="flex justify-between items-center">
        <div class="pb-2">
          <el-form>
            <el-form-item>
              <el-input class="w-full" v-model="search" placeholder="Search">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="flex items-center -mt-6">
          <div
            class="btn p-1 mr-3.5 pl-2 pr-2 flex items-center justify-center cursor-not-allowed"
          >
            <filter-icon />
            <p class="text-sm font-normal text-root-4 ml-2">Filter</p>
          </div>
          <div
            class="btn p-1 pl-1.5 pr-1.5 flex items-center justify-center cursor-not-allowed"
          >
            <downward-arrow-icon />
            <p class="text-sm font-normal text-root-4 ml-2">Download</p>
          </div>
        </div>
      </div> -->
      <!--table-->
      <div class="-mt-8">
        <el-table
          class="relative cursor-pointer py-5 font-normal"
          :class="{ minHeight: noData }"
          index
          :data="tableData"
          style="width: 100%"
          @row-click="toCustomerDetails"
        >
          <el-table-column class="w-full" width="80">
            <template slot-scope="scope">
              <el-avatar :size="50">
                {{ scope.row.customerName.charAt(0).toUpperCase() }}
              </el-avatar>
            </template>
          </el-table-column>
          <el-table-column width="auto">
            <template slot-scope="scope">
              <div class="font-bold capitalize">
                {{ scope.row.customerName }}
              </div>
              <div class="text-xs text-gray-40 font-normal">
                {{ scope.row.email }}
              </div>
            </template>
          </el-table-column>
          <el-table-column width="auto">
            <template slot-scope="scope">
              <div style="word-break: break-all">
                {{ maskID(scope.row.id) }}
              </div>
              <div class="text-xs text-gray-40 font-normal">Customer ID</div>
            </template>
          </el-table-column>
          <el-table-column width="auto">
            <template slot-scope="scope">
              <div style="word-break: break-all" class="uppercase">
                {{ scope.row.reference }}
              </div>
              <div class="text-xs text-gray-40 font-normal">
                Partner Reference
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column width="auto">
            <template slot-scope="scope">
              <div class="flex items-center">
                <div class="mr-1">
                  <currency-icons
                    :currency="getCurrencyCountry(scope.row.currency)"
                  />
                </div>
                <div class="uppercase">{{ scope.row.currency }}</div>
              </div>
              <div
                style="word-break: normal"
                class="text-xs font-normal text-gray-40"
              >
                Currency
              </div>
            </template>
          </el-table-column> -->
          <el-table-column width="auto">
            <template slot-scope="scope">
              <div>
                {{ $dayjs(scope.row.createdAt).format('DD MMM YY') }}
              </div>
              <div class="text-xs font-normal text-gray-40">
                {{ parseTime(scope.row.createdAt) }}
                {{ $dayjs(scope.row.createdAt).format(' A') }}
              </div>
            </template>
          </el-table-column>
          <el-table-column width="100">
            <template>
              <div class="flex items-center">
                <view-icon />
                <div class="text-xs font-normal ml-2">View</div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="p-6 grid grid-cols-1 md:justify-items-end">
          <el-pagination
            @current-change="handleCurrentChange"
            :page-size="page.size"
            @next-click="next"
            @prev-click="previous"
            background
            layout="prev, pager, next"
            :total="page.totalCount"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <filter-yield-dialog
      :showDialog="showFilterDialog"
      @closeDialog="closeFilterDialog"
      v-if="showFilterDialog"
    />
    <download-dialog
      :showDialog="showDownloadDialog"
      @closeDialog="closeDownloadDialog"
      v-if="showDownloadDialog"
    />
  </div>
</template>

<script>
import {
  ParseServerDates,
  MaskID,
  ParseTime,
  GetCurrencyCountry
} from '@/utils/helpers'
import getCustomers from '@/mixins/externalApi.js'
export default {
  name: 'CustomerTable',
  mixins: [getCustomers],
  components: {
    ViewIcon: () => import('@/assets/icons/ViewIcon.vue'),
    FilterYieldDialog: () =>
      import('@/components/externalApi/dialogs/FilterTransactionDialog.vue'),
    DownloadDialog: () =>
      import('@/components/externalApi/dialogs/DownloadDialog.vue')
    // CurrencyIcons: () => import('@/assets/icons/CurrencyIcons.vue')
  },
  props: {
    tableData: Array,
    page: Object,
    tableType: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isLoading: false,
      search: '',
      showFilterDialog: false,
      showDownloadDialog: false,
      payload: {
        page: 1,
        size: 10,
        status: '',
        type: '',
        from: '',
        to: ''
      }
    }
  },
  methods: {
    parseServerDates (val) {
      return ParseServerDates(val)
    },
    parseTime (val) {
      return ParseTime(val)
    },
    maskID (val) {
      return MaskID(val)
    },
    // filter () {
    //   this.showFilterDialog = true
    // },
    // download () {
    //   this.showDownloadDialog = true
    // },
    getCurrencyCountry (val) {
      return GetCurrencyCountry(val)
    },
    closeFilterDialog () {
      this.showFilterDialog = false
    },
    closeDownloadDialog () {
      this.showDownloadDialog = false
    },
    handleCurrentChange (val) {
      this.payload.page = val
      if (this.tableType === 'allCustomersTable') {
        this.getCustomers()
      } else {
        this.getYieldProfileCustomers()
      }
    },
    next () {
      this.payload.page++
      if (this.tableType === 'allCustomersTable') {
        this.getCustomers()
      } else {
        this.getYieldProfileCustomers()
      }
    },
    previous () {
      this.payload.page--
      if (this.tableType === 'allCustomersTable') {
        this.getCustomers()
      } else {
        this.getYieldProfileCustomers()
      }
    },
    toCustomerDetails (row) {
      this.$router.push(`/api-management/customer/${row.id}`)
    }
  },
  computed: {
    noData () {
      return this.tableData.length === 0
    }
  }
}
</script>

<style scoped>
.card {
  box-shadow:
    0px 0px 1px rgba(3, 2, 7, 0.12),
    0px 2px 4px rgba(3, 2, 7, 0.12);
  border-radius: 10.79px;
}
.btn {
  background: rgba(1, 5, 44, 0.05);
  border: 0.719333px solid #c1c4ca;
  border-radius: 6px;
}
>>> .el-tabs__item {
  color: var(--text-4);
}
>>> .el-input__inner {
  border-radius: 28px;
  height: 30px;
}
>>> .el-table th {
  background: var(--background);
  border: none;
}
>>> .el-table tr {
  background: var(--background);
  border: none;
}
>>> .el-table th.el-table__cell > .cell {
  background-color: rgba(243, 244, 246, var(--tw-bg-opacity));
  padding: 0.8rem 0rem;
}
>>> .el-select .el-input .el-select__caret {
  color: var(--color-primary);
}
>>> .el-pagination.is-background .btn-next.disabled,
.el-pagination.is-background .btn-next:disabled,
.el-pagination.is-background .btn-prev.disabled,
.el-pagination.is-background .btn-prev:disabled,
.el-pagination.is-background .el-pager li.disabled {
  background: green !important;
}
>>> .el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
  background: var(--background-2) !important;
}
>>> li.number.active {
  background-color: var(--background) !important;
  border: 0.5px solid var(--color-primary) !important;
  box-sizing: border-box;
  border-radius: 100px;
  font-weight: 400;
  color: var(--color-primary) !important ;
}
>>> li.number {
  background-color: var(--background) !important;
  border: 0.5px solid var(--text-1) !important;
  box-sizing: border-box;
  border-radius: 100px !important;
  font-weight: 400;
  /* color: var(--color-primary) !important ; */
}
.minHeight {
  height: 30vh;
}
</style>
